module.exports = __webpack_public_path__ + "img/purpose_Image_one.48d666d2.png";